import { useEffect, useId, useState } from 'react';
import styles from './progressbar.module.scss';

export interface ProgressBarProps {
    value: number;
}

export function ProgressBar({ value }: ProgressBarProps) {
    const labelId = useId();
    // Render 0% on first paint so a non-zero `value` (from default-checked items
    // or restored sessionStorage) animates up via the CSS transition on the fill.
    // Reduced-motion users get the snap-to-value behavior from the SCSS
    // `prefers-reduced-motion: reduce` rule that disables the transition.
    const [fillWidth, setFillWidth] = useState(0);

    useEffect(() => {
        setFillWidth(value);
    }, [value]);

    const displayLabel = `Setup ${value}% complete`;

    return (
        <div className={styles.container}>
            <p id={labelId} className={styles.label}>{displayLabel}</p>
            <div className={styles.track} role="progressbar" aria-valuenow={value} aria-valuemin={0} aria-valuemax={100} aria-labelledby={labelId}>
                <div className={styles.fill} style={{ width: `${fillWidth}%` }} />
            </div>
        </div>
    );
}
